export const Metrics = {
    ViewMFAForm: 'View MFA Auth Verification Section',
    ClickVerificationCode: 'Click Verification Code Textbox',
    ClickContinue: 'Click Verification Code Continue Button',
    ClickClose: 'Click Verification Code Close Icon',
    ViewErrorMessage: 'View Verification Code Error Message',
    ClickResend: 'Click Resend Code',
    ClickContactUs: 'Click Contact Us Link',
};

/**
 * @enum {MFA_VERIFICATION_TYPE}
 */
export const MFAVerificationTypes = {
    sms: 'sms',
    call: 'call',
    email: 'email',
};

// These url prefixes are used to match against provider pages that a provider will land on when they sign in.
// For the complete list:
// https://github.com/Zocdoc/zocdoc_web/blob/master/ZocDoc.Constants/Provider/Auth/PageFlowControlConstants.cs
export const PROVIDER_URL_PREFIX = '/provider';
export const PROFESSIONAL_URL_PREFIX = '/professionals';

export const LOCKED_USER_REDIRECT = '/locked';
export const BASE_EXPIRED_PASSWORD_REDIRECT =
    '/auth/ResetPassword?passwordexpired=true';

export const SIGN_IN_SUCCESS = '@@signinform/SIGN_IN_SUCCESS';
export const SIGN_IN_LOCKED_USER = '@@signinform/SIGN_IN_LOCKED_USER';

/**
 * @enum {MFA_ERROR_CODE}
 */
export const MFA_ERROR_CODES = {
    AuthenticationAlreadyCompleted: 'phone_authentication_already_completed',
    CodeChallengeExpired: 'code_challenge_expired',
    CodeChallengeIncorrect: 'code_challenge_incorrect',
    Default: 'default',
    InvalidBodyParams: 'invalid_body_params',
    InvalidPhoneFormat: 'invalid_phone_format',
    InvalidVerificationChannel: 'invalid_verification_channel',
    LandlinePhoneCannotReceieveSms: 'landline_phone_cannot_receive_sms',
    MalformedVerificationCode: 'malformed_verification_code',
    MissingPassword: 'password_missing',
    MissingUsername: 'email_missing',
    PhoneLocked: 'phone_locked',
    PhoneRevealFailed: 'could_not_reveal_phone',
    TooManyAttempts: 'too_many_attempts',
    TooManyRequests: 'too_many_requests',
    UserRateLimited: 'user_rate_limited_for_authentication',
};

export const MaxMfaAttemptsReachedErrorCodes = new Set([
    MFA_ERROR_CODES.TooManyAttempts,
    MFA_ERROR_CODES.TooManyRequests,
    MFA_ERROR_CODES.UserRateLimited,
]);

export const SERVICE_PHONE_NUMBER = '855-962-3621';
